import commonConstant from "@/constants/commonConstant";
import {
    STEP_CLOSE, STEP_COMPETITION, STEP_START, STEP_WHITELIST, STEP_WHITELIST_APPLIED,
    STEP_WHITELIST_CLOSE, STEP_WHITELIST_FAIL, STEP_WHITELIST_WIN
} from "@/seed/constants/timeline";
import { checkTimeline, formatNumber } from "@/seed/utils/common"; //
import moment from "moment-timezone";

export const convertPoolEventInfo = (poolEvent, customerAddress) => {
    let currentStep = 0;
    // check process in competition period
    let competitionPeriodStartAt = poolEvent.competitionPeriodEndAt;
    let competitionPeriodEndAt = poolEvent.competitionPeriodEndAt;
    let competitionTimeline = checkTimeline(
        competitionPeriodStartAt,
        competitionPeriodEndAt
    );
    currentStep = getCurrentStep(competitionTimeline, [
        STEP_START,
        STEP_START,
        STEP_COMPETITION,
    ]);
    let countdownFrom = moment(new Date()).valueOf();
    let countdownTo = moment(poolEvent.competitionPeriodEndAt).valueOf();
    let isCompleted = competitionTimeline == 2 ? 1 : 0;
    const { winners, currentCustomer } = whitelistResult(
        poolEvent,
        customerAddress
    );
    // in case competition is not complete
    if (isCompleted == 0) {
        return generateDataInfo({
            currentStep,
            countdownFrom,
            countdownTo,
            isCompleted,
            poolEvent,
            customerAddress,
            currentCustomer,
        });
    }
    // check process in whitelist period
    let whitelistPeriodStartAt = poolEvent.whitelistPeriodStartAt;
    let whitelistPeriodEndAt = poolEvent.whitelistPeriodEndAt;
    let whitelistTimeline = checkTimeline(
        whitelistPeriodStartAt,
        whitelistPeriodEndAt
    );
    let currentStepWhitelist = getCurrentStep(whitelistTimeline, [
        STEP_WHITELIST,
        STEP_WHITELIST,
        STEP_WHITELIST,
    ]);
    let isCompletedWhitelist = whitelistTimeline == 2 ? 1 : 0;
    // in case whitelist is not complete
    if (isCompletedWhitelist == 0) {
        return generateDataInfo({
            currentStep: currentStepWhitelist,
            countdownFrom: moment(whitelistPeriodStartAt).valueOf(),
            countdownTo: moment(whitelistPeriodEndAt).valueOf(),
            isCompleted: isCompletedWhitelist,
            poolEvent,
            customerAddress,
            currentCustomer,
        });
    } else {
        // check in case swap token is not still happen
        let swapTokenTimeline = checkTimeline(
            new Date().toISOString(),
            poolEvent.swapTokenPeriodStartAt
        );
        if (swapTokenTimeline != 2) {
            // check status of whitelist: win, fail or close (not login)
            if (!customerAddress) {
                // user has not login
                currentStepWhitelist = STEP_WHITELIST_CLOSE;
            } else {
                // check user has win or fail whitelist
                if (currentCustomer.length <= 0) {
                    currentStepWhitelist = STEP_WHITELIST_FAIL;
                } else {
                    currentStepWhitelist = STEP_WHITELIST_WIN;
                }
            }
            return generateDataInfo({
                currentStep: currentStepWhitelist,
                countdownFrom: moment(
                    poolEvent.swapTokenPeriodStartAt
                ).valueOf(),
                countdownTo: moment(poolEvent.swapTokenPeriodEndAt).valueOf(),
                isCompleted: isCompletedWhitelist,
                poolEvent,
                customerAddress,
                currentCustomer,
            });
        }
    }

    // check process in swap token period
    let swapTokenPeriodStartAt = poolEvent.swapTokenPeriodStartAt;
    let swapTokenPeriodEndAt = poolEvent.swapTokenPeriodEndAt;
    let swapTokenTimeline = checkTimeline(
        swapTokenPeriodStartAt,
        swapTokenPeriodEndAt
    );
    let currentStepSwapToken = getCurrentStep(swapTokenTimeline, [
        STEP_WHITELIST_CLOSE,
        STEP_PURCHASE_TOKEN,
        STEP_PURCHASE_TOKEN,
    ]);
    let isCompletedSwapToken = swapTokenTimeline == 2 ? 1 : 0;
    console.log("isCompletedSwapToken:", isCompletedSwapToken);
    console.log("swapTokenTimeline:", swapTokenTimeline);
    console.log("swapTokenPeriodStartAt:", swapTokenPeriodStartAt);
    console.log("swapTokenPeriodEndAt:", swapTokenPeriodEndAt);
    // in case swapToken is not complete
    if (isCompletedSwapToken == 0) {
        return generateDataInfo({
            currentStep: currentStepSwapToken,
            countdownFrom: moment(swapTokenPeriodStartAt).valueOf(),
            countdownTo: moment(swapTokenPeriodEndAt).valueOf(),
            isCompleted: isCompletedSwapToken,
            poolEvent,
            customerAddress,
            currentCustomer,
        });
    }
    // swap token completed
    let result = generateDataInfo({
        currentStep: STEP_CLOSE,
        countdownFrom: moment(swapTokenPeriodStartAt).valueOf(),
        countdownTo: moment(swapTokenPeriodEndAt).valueOf(),
        isCompleted: isCompletedSwapToken,
        poolEvent,
        customerAddress,
        currentCustomer,
    });
    return result;
};

/**
 *
 * @param {number} timeLine
 * @param {array} processArray: always 3 items: 0.before, 1.in, 2.after
 * @returns
 */
const getCurrentStep = (timeLine, processArray) => {
    if (timeLine == 0) {
        return processArray[0];
    }
    if (timeLine == 1) {
        return processArray[2];
    }
    return processArray[3];
};

/**
 * generate data info
 * @param {ojbect} info
 * @returns
 */
const generateDataInfo = (info) => {
    const {
        currentStep,
        countdownFrom,
        countdownTo,
        isCompleted,
        poolEvent,
        customerAddress,
        currentCustomer,
    } = info;
    let result = {
        currentStep,
        bg: {
            img: "/img/token-sale-bg.webp",
            width: 1440,
            height: 800,
        },
        applyBtn: setApplyButton(currentStep),
        content: setContentLayout(currentStep),
        countdown: setCountdown(currentStep, countdownFrom, countdownTo),
        completedStep: isCompleted,
        timeline: setTimeline(poolEvent),
        roundInfo: roundInfo(poolEvent),
        whitelistResult: whitelistResult(poolEvent, customerAddress),
        purchaseTokenInfo: purchaseTokenInfo(
            poolEvent,
            customerAddress,
            currentCustomer
        ),
    };
    return result;
};

/**
 * set apply whitelist button
 * @param {number} currentStep
 * @returns
 */
const setApplyButton = (currentStep) => {
    let show = false;
    let disable = false;
    switch (currentStep) {
        case STEP_START:
        case STEP_COMPETITION:
            show = true;
            disable = true;
            break;
        case STEP_WHITELIST:
            show = true;
            disable = false;
            break;
    }
    return {
        show,
        disable,
    };
};

/**
 * set content layout
 * @param {number} currentStep
 * @returns
 */

const setContentLayout = (currentStep) => {
    let layout = "";
    let lb0 = "";
    let lb1 = "";
    let lb2 = "";
    switch (currentStep) {
        case STEP_START:
        case STEP_COMPETITION:
            layout = "upcoming";
            lb1 = "stay tune";
            lb2 = "The whitelist is not open yet";
            break;
        case STEP_WHITELIST:
            layout = "whitelist-open";
            lb1 = "whitelist opens";
            lb2 = "The whitelist is now open. Your turn!";
            break;
        case STEP_WHITELIST_WIN:
            layout = "whitelist-win";
            lb0 = "Congratulation!";
            lb1 = "you win whitelist";
            lb2 = "Congrats! Your Guaranteed allocation for this pod is";
            break;
        case STEP_WHITELIST_FAIL:
            layout = "whitelist-fail";
            lb0 = "We are sorry !";
            lb1 = "just a bad luck !";
            lb2 =
                "Unfortunately, you didn’t win a guaranteed allocation for this pool. However, you still can join FCFS Phase if there is any token left from  Phase 1";
            break;
        case STEP_WHITELIST_APPLIED:
            layout = "whitelist-applied";
            lb1 = "applied whitelist";
            lb2 =
                "Allocation Result will be announced on Thursday, Dec 16, 2022";
            break;
        case STEP_WHITELIST_CLOSE:
            layout = "whitelist-close";
            lb1 = "whitelist closed";
            lb2 =
                "Allocation Result will be announced on Thursday, Dec 16, 2022";
            break;
        case STEP_PURCHASE_TOKEN:
            layout = "token-purchase";
            lb1 = "buy token...";
            lb2 = "Buying in progress and will be done";
            break;
        case STEP_CLOSE:
            layout = "token-purchase-close";
            lb1 = "Seed Round Closed";
            break;
    }
    return {
        layout,
        lb0,
        lb1,
        lb2,
    };
};

/**
 *
 * @param {number} currentStep
 * @param {number} countdownFrom
 * @param {number} countdownTo
 * @returns
 */

const setCountdown = (currentStep, countdownFrom, countdownTo) => {
    let from = countdownFrom;
    let to = countdownTo;
    let introLb = "";
    let displayFromTo = true;
    let tba = false;
    switch (currentStep) {
        case STEP_START:
        case STEP_COMPETITION:
            introLb = "";
            displayFromTo = true;
            tba = false;
            break;
        case STEP_WHITELIST:
            introLb = "End to join whitelist in";
            displayFromTo = true;
            tba = false;
            break;
        case STEP_WHITELIST_CLOSE:
            introLb = "End to join whitelist in";
            displayFromTo = true;
            tba = false;
            break;
    }
    return {
        from,
        to,
        introLb,
        displayFromTo,
        tba,
    };
};

/**
 * set timeline project
 * @param {object} poolEvent
 * @returns
 */
const setTimeline = (poolEvent) => {
    let steps = [];
    // check process in competition period
    let competitionPeriodStartAt = poolEvent.competitionPeriodEndAt;
    let competitionPeriodEndAt = poolEvent.competitionPeriodEndAt;
    let competitionTimeline = checkTimeline(
        competitionPeriodStartAt,
        competitionPeriodEndAt
    );
    let isCompetitionCompleted = competitionTimeline == 2 ? 1 : 0;
    steps.push({
        step: 1,
        title: "Upcoming",
        time: moment(poolEvent.competitionPeriodEndAt).format(
            commonConstant.FORMAT_DATE_YMD_HMS
        ),
        isCompleted: isCompetitionCompleted,
    });

    // check process in whitelist period
    let whitelistPeriodStartAt = poolEvent.competitionPeriodEndAt;
    let whitelistPeriodEndAt = poolEvent.swapTokenPeriodStartAt;
    let whitelistTimeline = checkTimeline(
        whitelistPeriodStartAt,
        whitelistPeriodEndAt
    );
    let isWhitelistCompleted = whitelistTimeline == 2 ? 1 : 0;
    steps.push({
        step: 2,
        title: "Whitelist Open",
        time: poolEvent.competitionPeriodEndAt,
        isCompleted: isWhitelistCompleted,
    });

    // check process in sale token period
    let saleTokenPeriodStartAt = poolEvent.swapTokenPeriodStartAt;
    let saleTokenPeriodEndAt = poolEvent.swapTokenPeriodEndAt;
    let saleTokenTimeline = checkTimeline(
        saleTokenPeriodStartAt,
        saleTokenPeriodEndAt
    );
    let isSaleTokenCompleted = saleTokenTimeline == 2 ? 1 : 0;
    steps.push({
        step: 3,
        title: "Sale Open",
        time: poolEvent.swapTokenPeriodStartAt,
        isCompleted: isSaleTokenCompleted,
    });

    // check process in close
    let closePeriodStartAt = poolEvent.swapTokenPeriodStartAt;
    let closePeriodEndAt = poolEvent.swapTokenPeriodEndAt;
    let closeTimeline = checkTimeline(closePeriodStartAt, closePeriodEndAt);
    let isCloseCompleted = closeTimeline == 2 ? 1 : 0;
    steps.push({
        step: 4,
        title: "Close",
        time: poolEvent.swapTokenPeriodStartAt,
        isCompleted: isCloseCompleted,
    });

    return {
        star: {
            img: "/img/star@3x.webp",
            width: 90,
            height: 87,
        },
        starGlow: {
            img: "/img/star-glow@3x.png",
            width: 90,
            height: 87,
        },
        steps: steps,
    };
};

/**
 * get round info
 * @param {object} poolEvent
 * @returns
 */
export const getRoundInfo = (poolEvent, options) => {
    let data = [];
    let title = poolEvent?.pool?.title;
    // get sale price
    let salePrice = poolEvent?.pricePerToken;
    const price = roundDetailItem("Sale Price", `${salePrice} BUSD`, false);
    data.push(price);
    // Contribute Amount per slot
    let amountContributeTemp = formatNumber(poolEvent?.contributeAmountToken);
    
    // TODO: validate with smart contract
    const amountContribute = roundDetailItem(
        "Contribute Amount per slot",
        `${amountContributeTemp} BUSD`,
        false
    );
    data.push(amountContribute);
    // Available for Token Sale
    let availableAmountTokenTemp = poolEvent?.availableAmountToken;
    const availableAmountToken = roundDetailItem(
        "Available for Token Sale",
        `${formatNumber(availableAmountTokenTemp)} MDN`,
        false
    );
    data.push(availableAmountToken);
    // Total Raise
    let totalRaiseTemp =
        parseFloat(salePrice) * parseInt(availableAmountTokenTemp);
    const totalRaise = roundDetailItem(
        "Total Raise",
        `$${formatNumber(totalRaiseTemp)}`,
        true
    );
    data.push(totalRaise);
    // Accepted Currency
    const acceptCurrency = roundDetailItem(
        "Accepted Currency",
        // `BNB + BUSD`,
        options.acceptCurrency,
        false
    );
    data.push(acceptCurrency);
    // Network
    const network = roundDetailItem("Network", `Binance Smart Chain`, false);
    data.push(network);
    // Vesting Schedule
    const vestingSchedulePolicy = roundDetailItem(
        "Vesting Schedule",
        `${poolEvent?.claimTokenPolicy}`,
        true
    );
    data.push(vestingSchedulePolicy);

    return {
        title,
        contributeAmountToken: amountContributeTemp,
        details: data,
    };
};

/**
 * get round detail item
 * @param {string} title
 * @param {string} value
 * @param {bool} isSpecialValue
 * @returns
 */
const roundDetailItem = (title, value, isSpecialValue) => {
    return {
        title,
        value,
        isSpecialValue,
    };
};

/**
 * get whitelist result
 * @param {ojbect} info
 * @param {string} customerAddress
 * @returns
 */
const whitelistResult = (info, customerAddress) => {
    if (info?.whitelists) {
        let winners = info.whitelists.filter(function (el) {
            return el.isWinner;
        });
        let totalWinner = formatNumber(winners.length);

        // find customer in winners
        let currentCustomer = winners.filter(function (el) {
            return el.customerAddress == customerAddress;
        });
        return {
            winners,
            totalWinner,
            currentCustomer,
        };
    }
    return {
        winners: [],
        totalWinner: 0,
        currentCustomer: [],
    };
};

const purchaseTokenInfo = (info, customerAddress, currentCustomer) => {
    // check has whitelist and correct winner is user login
    if (info?.whitelists && currentCustomer.length > 0) {
        const amountRecieveMDN = Math.round(
            parseFloat(info.contributeAmountToken) /
                parseFloat(info.pricePerToken)
        );
        let purchaseForm = {
            whitelistWin: true,
            demandBalance: formatNumber(info?.contributeAmountToken),
            currency: "BUSD",
            approveBtn: {
                display: true,
                disable: false,
                label: "approve",
            },
            purchaseBtn: {
                display: false,
                disable: false,
                label: "purchase",
            },
            remindDesc:
                "You need to approve once (and only once) before you can start swapping",
            estimatedReceiveMDN: {
                title: "You will get approximately",
                value: formatNumber(amountRecieveMDN),
                currency: "MDN",
            },
        };
        return {
            purchaseForm,
        };
    }
    return {
        purchaseForm: {},
    };
};
